import { useFilters } from "@/src/hooks/useFilters";
import { useFormik } from "formik";
import { NextPage } from "next";
import { useRouter } from "next/navigation";
import { Input, InputGroup, InputGroupText } from "reactstrap";
import * as Yup from "yup";
const Search: NextPage = () => {
  const { handleProductName, handleFindByProductName, handleResetFilters } =
    useFilters();
  const route = useRouter();
  const formik = useFormik({
    initialValues: {
      nameProduct: "",
    },
    validationSchema: Yup.object({
      nameProduct: Yup.string()
        .min(2, "Debe ingresar al menos 2 caracteres")
        .matches(/^[a-zA-Z0-9\s\-:_.]+$/, "Solo se permiten letras y números")
        .required("El campo es requerido si desea realizar una busqueda"),
    }),
    onSubmit: (values) => {
      if (!values.nameProduct) return;
      if (values.nameProduct.length < 2) return;
      if (values.nameProduct.length > 150) return;
      const finalValue = values.nameProduct
        .replace(/\s+/g, " ")
        .replace(/\//g, " ")
        .toLowerCase()
        .trim();

      handleProductName(finalValue);
      handleFindByProductName(finalValue);
      route.replace(`/buscar/${finalValue}/`);
    },
  });
  return (
    <div className="input-block">
      <div className="input-box">
        <form className="big-deal-form" onSubmit={formik.handleSubmit}>
          <InputGroup>
            <InputGroupText>
              <button
                type="submit"
                className="search"
                style={{
                  cursor: "pointer",
                  color: "#000",
                  fontSize: "1.5rem",
                  border: "none",
                  background: "none",
                }}
              >
                <i
                  className="fa 
                       fa-search"
                ></i>
              </button>
            </InputGroupText>
            <Input
              type="text"
              placeholder="Buscar ..."
              className="form-control"
              name="nameProduct"
              value={formik.values.nameProduct}
              onChange={formik.handleChange}
              onBlur={(e) => {
                formik.handleBlur(e);
                if (location.pathname.includes("buscar")) {
                  if (formik.values.nameProduct == "") {
                    formik.resetForm();
                    route.replace(`/buscar/"`);
                    handleResetFilters();
                  }
                }
              }}
            />
            {formik.touched.nameProduct && formik.errors.nameProduct && (
              <div className="search_error">{formik.errors.nameProduct}</div>
            )}
          </InputGroup>
        </form>
      </div>
    </div>
  );
};

export default Search;
